<template>
  <div
    class="jad-block-carousel-banner"
  >
    <j-carousel
      :height="480"
      :autoplay="true"
      :loop="true"
      :autoplay-speed="3000"
      arrow="never"
    >
      <j-carousel-item v-for="(item, index) in bannerList" :key="index">
        <div
          class="jad-block-carousel-banner-carousel-item"
          :style="{
            'background-image': 'url('+ item.imgUrl +')',
          }"
        >
          <div
            class="jad-block-carousel-banner-carousel-item-content"
          >
            <div
              class="jad-block-carousel-banner-carousel-item-content-title"
            ><span>{{ item.title }}</span></div>
            <div
              class="jad-block-carousel-banner-carousel-item-content-desc"
            >{{ item.description }}</div>
            <cloud-button
              :text="item.router"
              :handleClick="() => open(item.link)"
            ></cloud-button>
          </div>
        </div>
      </j-carousel-item>
    </j-carousel>
  </div>
</template>

<script>
import cloudButton from "./cloudButton";
export default {
  components: {
    cloudButton: cloudButton,
  },
  data() {
    return {
      bannerList: [
        {
          imgUrl: '//img10.360buyimg.com/img/jfs/t1/206063/17/50015/49528/673da4e1F231cfd34/fd0d0c00039e13f9.jpg',
          title: '数预趋势 智驭增长',
          description: '京东DAAS整合平台数智产品能力，打造一站式数智服务平台，基于经营增长、用户增长、营销提效、新品创新等四大场景，助力品牌长效增长',
          link: '/cloud/about/us',
          router:'立即咨询'
        },
        {
          imgUrl: '//img10.360buyimg.com/img/jfs/t1/266787/6/363/205756/6763f7a5F432bf671/db8a7d84896df3a1.jpg',
          title: '第六届京旗\n数智案例大赛',
          description: '获奖名单',
          link: 'https://jzt.jd.com/static/yxy-jqsz/6',
          router:'了解更多'
        }
      ]
    };
  },
  methods: {
    open(url) {
      if (!url) return
      window.open(url, '_blank')
    },
  },
};
</script>
<style lang="scss" scope>
.jad-carousel-indicator.is-active .jad-carousel-indicator-item{
    background:#3247FF !important;
}
.jad-carousel-indicator .jad-carousel-indicator-item{
    width: 110px !important;
    height: 11px !important;
    background: #D2D2D2;
    opacity: 1;
}
.jad-block-carousel-banner {
    position: relative;
    width: 100%;
    height: auto;
    margin-top: 60px;
  .jad-carousel-item {
    background: #fff;
  }
  .jad-carousel-container {
    border-radius: 6px;
    overflow: hidden;
  }
  &-no-radius{
    .jad-carousel-container {
      border-radius: 0;
    }
  }
  &-has-panel {
    .jad-carousel-indicators {
      bottom: 84px;
      width: 61.5%;
      transform: none;
      left: 19.25%;
    }
  }
  &-carousel-item {
    width: 100%;
    height: 100%;
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    background-color: rgb(255, 255, 255);
    background-size: cover;

    &-content {
      margin: 0 auto;
      text-align: left;
      width: 1168px;
      &-title {
        font-size: 42px;
        overflow:hidden;
        text-overflow:ellipsis;
         white-space: pre-wrap;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        color: #000;
        width: 520px;
        margin-top: 105px;
        font-weight: 500;
      }
      &-desc {
        font-size: 16px;
        line-height: 28px;
        color: #000;
        width: 485px;
        margin-top: 18px;
        margin-bottom: 60px;
      }
    }
  }
}
</style>